
// Helper to normalize status for UI
export const getUnifiedStatus = (book: any) => {
    // P2 V3 Logic: Trust Derived Status
    if (book.derivedStatus) {
        const s = book.derivedStatus.status;
        switch (s) {
            case 'ready': return { label: 'READY', color: '#2e7d32' };             // Green
            case 'processing': return { label: 'PROCESSING', color: '#1565c0' };  // Blue
            case 'needs_repair': return { label: 'NEEDS REPAIR', color: '#c62828' };// Red
            case 'missing': return { label: 'MISSING', color: '#757575' };          // Grey
            case 'partial_audio': return { label: 'PARTIAL AUDIO', color: '#ef6c00' };// Orange
            case 'text_ready': return { label: 'TEXT READY', color: '#8d6e63' };    // Brown
            case 'manifest_only': return { label: 'MANIFEST ONLY', color: '#ab47bc' };// Purple
            case 'unknown': return { label: 'UNKNOWN', color: '#424242' };
        }
        return { label: s.toUpperCase(), color: '#424242' };
    }

    // Legacy Fallback
    const job = book.activeJob;

    // 1. Completed
    if (book.overall === 'ready' || book.overall === 'ok') return { label: 'COMPLETED', color: '#4caf50' };
    if (job?.status === 'completed') return { label: 'COMPLETED', color: '#4caf50' };

    // 2. Failed
    if (book.overall === 'broken' || job?.status === 'failed') return { label: 'FAILED', color: '#ef5350' };

    // 3. Running / Stalled
    if (job) {
        // Stalled check: > 10 mins since last chunk or update
        const lastActivity = job.lastChunkAt || job.updatedAt || job.startedAt;
        const isStalled = lastActivity && (Date.now() - new Date(lastActivity).getTime()) > 600000;

        if (isStalled) return { label: 'STALLED', color: '#ffb74d' };
        return { label: 'RUNNING', color: '#2196f3' };
    }

    // 4. Queued
    if (book.overall === 'queued') return { label: 'QUEUED', color: '#90caf9' };

    // 5. Incomplete (Source/Arts present, but no job)
    if (book.overall === 'incomplete') return { label: 'READY', color: '#bdbdbd' };

    return { label: 'UNKNOWN', color: '#444' };
};

export const formatTimeAgo = (isoString?: string) => {
    if (!isoString) return '—';
    const ms = Date.now() - new Date(isoString).getTime();
    if (ms < 0) return 'Just now'; // Future timestamps handle
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);

    if (day > 0) return `${day}d ago`;
    if (hr > 0) return `${hr}h ago`;
    if (min > 0) return `${min}m ago`;
    return `${sec}s ago`;
};
